import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "leaf",
  "use": "leaf-usage",
  "viewBox": "0 0 113.81 130.36",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 113.81 130.36\" id=\"leaf\"><defs><style>#leaf .cls-1{fill:#e8e8e8;}</style></defs><g id=\"leaf_Layer_2\" data-name=\"Layer 2\"><g id=\"leaf_Layer_5\" data-name=\"Layer 5\"><path class=\"cls-1\" d=\"M2,77.61l54.71,52s3.57,2,6.35-.83,22.86-25.88,35.74-56.53c10.32-24.57,15.15-60.39,15-66S107.33,0,107.33,0,37.32.58,34.5.63a7.44,7.44,0,0,0-7,5.79C27,9.2,25.73,24.13,19,39.81S2.61,67.24,1.11,69.84C-.94,73.42.15,75.17,2,77.61Z\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol